/* eslint-disable @typescript-eslint/no-unsafe-function-type */
export function useResume() {
  const { $myFetch } = useNuxtApp();
  const router = useRouter();
  const information = useInformation();
  const interviewStatus = useState<{
    eligible: boolean,
    ongoing_thread: null | {
      thread_id: string,
      status: string
      last_message: string
    },
    showResumeTip: boolean
  }>('interviewStatus', () => ({
    eligible: false,  // 是否有面试资格
    ongoing_thread: null,
    showResumeTip: false
  }))
  async function checkInterviewStatus() {
    const unionid = localStorage.getItem('unionid')
    if (unionid) {
      const data = await ($myFetch as Function)(`/users/${unionid}/interview-status`)
      information.value.thread_id = data.ongoing_thread?.thread_id
      interviewStatus.value = data
      if (data.eligible) {
        interviewStatus.value.showResumeTip = true
      }
    }
  }
  function resumeInterview() {
    interviewStatus.value.showResumeTip = false
    if (interviewStatus.value.ongoing_thread?.thread_id && interviewStatus.value.ongoing_thread?.status === 'ongoing') {
      router.replace(`/chat?thread_id=${interviewStatus.value.ongoing_thread?.thread_id}&audio=true&video=false`)
    } else {
      router.replace('/information/position')
    }
  }
  return {
    interviewStatus,
    checkInterviewStatus,
    resumeInterview
  }
}
